import { GuardianLayout } from '@/components/layout/guardian'
import { ClientOnly } from '@/components/ClientOnly'
import { FullScreenLoading } from '@/components/FullScreenLoading'
import Router from 'next/router'
import { use } from 'react'

export default function Home() {
  use(Router.replace('/web/user-setting/'))
}

Home.getLayout = (page: React.ReactNode) => (
  <ClientOnly fallback={<FullScreenLoading />}>
    <GuardianLayout>{page}</GuardianLayout>
  </ClientOnly>
)
